/** Copyright 2024 SAP SE or an SAP affiliate company. All rights reserved. */
import { RadioButton, Text, FlexBox } from '@ui5/webcomponents-react';
import { useEffect, useState } from 'react';
import { actions } from '../../store/Products';
import * as storageUtils from '../../utils/storageUtils';
import { useTranslations } from '../../hooks/useTranslations';
import { useAppDispatch } from '@/hooks/useAppDispatch';
import TaskTitle from '../TaskTitle/TaskTitle';
import { useAppSelector } from '@/hooks';
import TaskIcon from '@/components/TaskIcon';

const sectionStyle = {
    display: 'flex',
    flexDirection: 'column' as const,
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    width: '100%',
};

export const CommodityCode: React.FC<any> = ({ content }) => {
    const personalizationValue = content.personalizationConfiguration?.configurationValue;
    const [commodityCode, setCommodityCode] = useState<string>();
    const dispatch = useAppDispatch();
    const productList = useAppSelector(state => state.productList);
    const USER_ID = storageUtils.getItem('user').user_uuid;
    const { t } = useTranslations();

    const handleChange = (event: any) => {
        const value = event.target.value;
        setCommodityCode(value);
        dispatch(
            actions.setCurrentProductConfigurationValue({
                productRunId: productList.currentRunId,
                taskId: content.id,
                configurationKey: content.productConfigurationKey,
                configurationValue: value,
                updatedBy: USER_ID,
                personalizationConfiguration: content.personalizationConfiguration,
            })
        );
        dispatch(
            actions.setCurrentProductConfigKeys({
                key: content.productConfigurationKey,
                value,
            })
        );
        dispatch(actions.setCommodityCode({ codes: [], commodityCodeType: value }));
    };

    useEffect(() => {
        if (personalizationValue) {
            setCommodityCode(personalizationValue);
        } else {
            setCommodityCode(content.defaultValue);
        }
        dispatch(
            actions.setCurrentProductConfigurationValue({
                productRunId: productList.currentRunId,
                taskId: content.id,
                configurationKey: content.productConfigurationKey,
                configurationValue: personalizationValue ? personalizationValue : content.defaultValue,
                updatedBy: USER_ID,
                personalizationConfiguration: content.personalizationConfiguration,
            })
        );
        dispatch(
            actions.setCurrentProductConfigKeys({
                key: content.productConfigurationKey,
                value: commodityCode,
            })
        );
        dispatch(actions.setCommodityCode({ codes: [], commodityCodeType: personalizationValue ? personalizationValue : content.defaultValue }));
    }, []);

    return (
        <div className="content__datacontroller" data-testid="commodity-code">
            <section style={sectionStyle}>
                <TaskIcon icon="group-2" />
                <TaskTitle />
                <Text>{t('COMMODITY_CODE_FAMILY_QSN_TEXT')}</Text>
                <div role="radiogroup" style={{ padding: '1rem' }}>
                    <FlexBox>
                        <RadioButton
                            name="commodityCode"
                            text={t('UNSPSC')}
                            checked={commodityCode === 'unspsc'}
                            value="unspsc"
                            onChange={handleChange}
                            data-testid="btn-UNSPSC"
                        />
                    </FlexBox>
                    <FlexBox>
                        <RadioButton
                            name="commodityCode"
                            text={t('CUSTOM')}
                            checked={commodityCode === 'custom'}
                            value="custom"
                            onChange={handleChange}
                            data-testid="btn-CUSTOM"
                        />
                    </FlexBox>
                </div>
            </section>
        </div>
    );
};
export default CommodityCode;
